// angular import
import { Component, effect, inject, OnInit } from '@angular/core';

// project import
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { SharedModule } from 'src/app/@core/shared/shared.module';

// const import
import { VERTICAL, HORIZONTAL, COMPACT } from 'src/app/@theme/const';

@Component({
  selector: 'app-nav-left',
  imports: [SharedModule],
  templateUrl: './toolbar-left.component.html',
  styleUrls: ['./toolbar-left.component.scss']
})
export class NavLeftComponent implements OnInit {
  private themeService = inject(ThemeLayoutService);

  mobileMedia: boolean;

  // public props
  showToggleMenu: boolean = true;

  // constructor
  constructor() {
    effect(() => {
      this.updateThemeLayout(this.themeService.layout());
    });
  }

  ngOnInit() {
    this.themeService.ismobile.subscribe((result: boolean) => {
      if (result) {
        this.mobileMedia = true;
      } else {
        this.mobileMedia = false;
      }
    });
  }

  private updateThemeLayout(layout: string) {
    if (layout === VERTICAL) {
      this.showToggleMenu = true;
    }
    if (layout == HORIZONTAL) {
      this.showToggleMenu = false;
    }
    if (layout === COMPACT) {
      this.showToggleMenu = true;
    }
  }

  // public method
  toggleMenu() {
    this.themeService.toggleSideDrawer();
  }
}
